import {
    Checkbox,
    CheckboxProps,
    FormControlLabel,
    Grid,
    Typography,
} from '@mui/material';

type SttFormCheckProps = {
    grid?: boolean;
    name?: string;
    caption?: React.ReactNode;
    color?: CheckboxProps['color'];
    checked?: boolean;
    onChange?: (value: { name: string; value: unknown }) => void;
    disabled?: boolean;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    [key: string]: any;
};

export function SttFormCheck({
    grid = false,
    name,
    caption,
    color = 'default',
    checked = false,
    onChange,
    disabled,
    xs,
    sm,
    md,
    lg,
    xl,
    ...rest
}: SttFormCheckProps) {
    const content = (
        <FormControlLabel
            control={
                <Checkbox
                    color={color}
                    name={name}
                    onChange={(e: any) => {
                        if (!disabled) {
                            onChange?.({
                                name: name || '',
                                value: e.target.checked,
                            });
                        }
                    }}
                    checked={checked}
                    disabled={disabled}
                />
            }
            label={
                <Typography
                    variant="body2"
                    style={disabled ? { color: '#9f9f9f' } : {}}
                >
                    {caption}
                </Typography>
            }
        />
    );

    const sizeProps = { xs, sm, md, lg, xl };
    return grid ? (
        <Grid size={sizeProps} {...rest}>
            {content}
        </Grid>
    ) : (
        content
    );
}
